import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PolitiqueConfidentialitePage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <section className="bg-[#E30022] text-white py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl lg:text-4xl font-serif">Politique de confidentialité</h1>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8 lg:p-12 prose prose-gray max-w-none">
          <p className="text-gray-500 mb-8">Dernière mise à jour : Janvier 2026</p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">1. Introduction</h2>
          <p className="text-gray-600 mb-4">
            Recrutement Suisse SA (ci-après "Recrutement Suisse", "nous", "notre") s'engage à protéger la vie privée des utilisateurs de son site web et des candidats et clients qui utilisent ses services. Cette politique de confidentialité explique comment nous collectons, utilisons, partageons et protégeons vos données personnelles.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">2. Données collectées</h2>
          <p className="text-gray-600 mb-4">Nous collectons les types de données suivants :</p>
          <ul className="list-disc pl-6 text-gray-600 mb-4 space-y-2">
            <li><strong>Données d'identification :</strong> nom, prénom, adresse e-mail, numéro de téléphone</li>
            <li><strong>Données professionnelles :</strong> CV, lettre de motivation, parcours professionnel, formations, compétences</li>
            <li><strong>Données de navigation :</strong> adresse IP, type de navigateur, pages visitées, durée de visite</li>
            <li><strong>Données de communication :</strong> historique de nos échanges, préférences de contact</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">3. Finalités du traitement</h2>
          <p className="text-gray-600 mb-4">Vos données sont traitées pour les finalités suivantes :</p>
          <ul className="list-disc pl-6 text-gray-600 mb-4 space-y-2">
            <li>Gestion des candidatures et mise en relation avec des employeurs potentiels</li>
            <li>Fourniture de nos services de recrutement et de conseil RH</li>
            <li>Communication sur nos offres d'emploi et actualités</li>
            <li>Amélioration de nos services et de notre site web</li>
            <li>Respect de nos obligations légales et réglementaires</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">4. Base légale</h2>
          <p className="text-gray-600 mb-4">
            Le traitement de vos données repose sur les bases légales suivantes : votre consentement, l'exécution d'un contrat, nos intérêts légitimes ou le respect d'une obligation légale.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">5. Partage des données</h2>
          <p className="text-gray-600 mb-4">
            Vos données peuvent être partagées avec :
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-4 space-y-2">
            <li>Nos clients employeurs dans le cadre du processus de recrutement</li>
            <li>Nos prestataires techniques (hébergement, outils de gestion)</li>
            <li>Les autorités compétentes sur demande légale</li>
          </ul>
          <p className="text-gray-600 mb-4">
            Nous ne vendons jamais vos données personnelles à des tiers.
          </p>
          <p data-testid="privacy-form-processing" className="text-gray-600 mb-4">
            Les demandes envoyées par les formulaires sont enregistrées dans notre base de données. Les CV sont conservés dans un stockage privé et joints aux notifications adressées à notre équipe via Gmail (Google). Ils ne sont pas accessibles par un lien public. Le consentement demandé concerne le traitement de votre demande, sans inscription automatique à des communications commerciales.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">6. Conservation des données</h2>
          <p className="text-gray-600 mb-4">
            Vos données sont conservées pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées, généralement 3 ans après le dernier contact pour les candidats, sauf obligation légale contraire.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">7. Vos droits</h2>
          <p className="text-gray-600 mb-4">
            Conformément à la Loi fédérale sur la protection des données (LPD) et au RGPD, vous disposez des droits suivants :
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-4 space-y-2">
            <li>Droit d'accès à vos données</li>
            <li>Droit de rectification des données inexactes</li>
            <li>Droit à l'effacement ("droit à l'oubli")</li>
            <li>Droit à la limitation du traitement</li>
            <li>Droit à la portabilité des données</li>
            <li>Droit d'opposition au traitement</li>
          </ul>
          <p className="text-gray-600 mb-4">
            Pour exercer vos droits, contactez-nous à : <a data-testid="privacy-rights-email" href="mailto:f.rosset@recrutement-suisse.ch" className="text-[#E30022] hover:underline break-all">f.rosset@recrutement-suisse.ch</a>
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">8. Sécurité</h2>
          <p className="text-gray-600 mb-4">
            Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">9. Contact</h2>
          <p className="text-gray-600 mb-4">
            Pour toute question relative à cette politique ou à vos données personnelles :<br/>
            Recrutement Suisse SA<br/>
            Limmatquai 112<br/>
            8001 Zürich<br/>
            <a data-testid="privacy-contact-email" href="mailto:f.rosset@recrutement-suisse.ch" className="text-[#E30022] hover:underline break-all">f.rosset@recrutement-suisse.ch</a>
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PolitiqueConfidentialitePage;
